import React from "react";
import DownloadBtn from "./DownloadBtn";
import HireMeBtn from "./HireMeBtn";
import { useEffect, useState } from "react";
import { Link } from "react-scroll";
import clsx from "clsx";
import { useSpring, animated } from "@react-spring/web";
import { navbar } from "../../lib/navbar";
const MenuDesktop = ({ openModalResume }) => {
  const [activeSection, setActiveSection] = useState("home");
  const fade = useSpring({
    opacity: activeSection === "home" ? 0 : 1,
    config: { duration: 300 },
  });
  useEffect(() => {
    const handleScroll = () => {
      // Get all sections on the page
      const sections = document.querySelectorAll("section");
      var threshold = -400; // Only update active section when 50px of the section is in view
      // Find the section that is currently in view
      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];

        const rect = section.getBoundingClientRect();
        if (rect.top >= threshold && rect.top <= window.innerHeight) {
          setActiveSection(section.id);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <ul className="items-center hidden md:flex ">
      {navbar.map((nav) => (
        <li key={nav.link}>
          <Link
            to={nav.to}
            smooth={true}
            duration={500}
            className={clsx(
              "py-2 hover:border-b-2 border-violet-600",
              activeSection === nav.active ? "border-b-2 border-violet-600" : ""
            )}
          >
            {nav.name}
          </Link>
        </li>
      ))}

      <li>
        <a onClick={openModalResume} download className="py-2">
          Resume
        </a>
      </li>
      <li>
        <a href="./Ahmaddin_resume.pdf" download className="py-2">
          <DownloadBtn />
        </a>
      </li>

      <animated.li style={{ ...fade, minWidth: "100px" }}>
        <HireMeBtn />
      </animated.li>
    </ul>
  );
};

export default MenuDesktop;
